export default "__VITE_ASSET__CUtJpr3b__"